import React, { useMemo } from 'react'
import * as Yup from 'yup'
import { RouteProps, useSearchParams } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { useDispatch, useSelector } from 'react-redux'

import InitPasswordTemplate, { InitPasswordTemplateProps } from '../../templates/Password/init'
import { useFooter } from '../../relay/Footer/useFooter'
import { useHeader } from '../../relay/Header/useHeader'
import { actions, selectors } from '../../redux'

const InitPasswordPage: React.FC<RouteProps> = () => {
  const { t } = useTranslation()
  const dispatch = useDispatch()
  const [searchParams] = useSearchParams()
  const header = useHeader()
  const footer = useFooter()
  const reset = useSelector(selectors.auth.reset)

  const templateProps: InitPasswordTemplateProps = useMemo(
    () => ({
      layout: {
        header,
        footer,
      },
      initPasswordForm: {
        background: `${import.meta.env.BASE_URL}images/onboarding/pickCCI.jpg`,
        header: {
          title: t('password.init.header.title'),
        },
        content: {
          title: t('password.init.content.title'),
          formikForm: {
            initialValues: {
              password: '',
              confirmPassword: '',
            },
            validationSchema: Yup.object().shape({
              password: Yup.string().required(),
              confirmPassword: Yup.string().oneOf(
                [Yup.ref('password')],
                t('form.error.samePassword')
              ),
            }),
            onSubmit: (values) => {
              dispatch(
                actions.auth.resetRequest({
                  token: searchParams.get('token') || '',
                  email: searchParams.get('email') || '',
                  password: values.password,
                })
              )
            },
            validateOnChange: false,
          },
          fields: {
            password: {
              name: 'password',
              label: t('password.init.password.label'),
              placeholder: t('password.init.password.placeholder'),
              required: true,
            },
            confirmPassword: {
              name: 'confirmPassword',
              label: t('password.init.confirmPassword.label'),
              placeholder: t('password.init.confirmPassword.placeholder'),
              required: true,
            },
          },
          errors: reset.errors,
          submitButton: {
            text: t('password.init.submit.label'),
            isPending: reset.pending,
            isSuccess: reset.success,
            pendingText: t('password.init.submit.pending'),
            successText: t('password.init.submit.success'),
          },
        },
      },
    }),
    [dispatch, footer, header, reset.errors, reset.pending, reset.success, searchParams, t]
  )

  return <InitPasswordTemplate {...templateProps} />
}

export default InitPasswordPage
